{
  "welcome_subtitle": "Mis proyectos en vivo",
  "welcome_title": "Bienvenido, {{ name }}",
  "view_project": "Ver proyecto",
  "my_projects": "Mis proyectos",
  "create_project_form": {
    "title": "Nuevo proyecto",
    "title_edit": "Editar proyecto",
    "project_name": "Nombre del proyecto",
    "project_expiry_date": "Fecha de caducidad del proyecto",
    "project_apps": "Aplicaciones y características",
    "billing_provider": "Proveedor de facturación",
    "subscription_plan": "Plan de suscripción",
    "subscription_plan_price": "Precio",
    "billing_invalid": "Selecciona un método de facturación",
    "plan_invalid": "Selecciona un plan",
    "price_invalid": "Por favor, selecciona un precio",
    "name_invalid": "Introduce un nombre.",
    "date_invalid": "Introduce una fecha válida después de hoy.",
    "max_users": "Número máximo de usuarios",
    "max_users_invalid": "El número máximo de usuarios debe ser superior a 0",
    "unlimited_users": "Usuarios ilimitados",
    "unlimited": "Ilimitado"
  },
  "billing_popover": {
    "renew_button": "Renueve la suscripción ahora",
    "body": "Tu suscripción ha caducado. Para recuperar el acceso a tu proyecto, renuévala hoy mismo."
  },
  "service_unavailable": {
    "body": "Este proyecto ha caducado. Ponte en contacto con el administrador del proyecto para renovar la suscripción.",
    "support": "Para obtener más ayuda, por favor"
  }
}